import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const active = {
  color: "#4187B6",
  "& path": {
    fill: "#4187B6",
  },
};

export const menuOptionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuLink: {
      textDecoration: "none",
      color: "black",
      fontWeight: 600,
    },
    menuOption: () => ({
      display: "flex",
      alignItems: "center",
      marginBottom: "5px",
      fontFamily: "Inter",
      cursor: "pointer",
      "&:hover": active,
      "& > span": {
        fontFamily: "Inter",
        fontSize: theme.typography.pxToRem(16),
        [theme.breakpoints.down("sm")]: {
          fontSize: theme.typography.pxToRem(18),
        },
      },
      gap: "10px",
    }),
    menuOptionActive: active,
    avatar: {
      width: "27.5px",
      height: "27.5px",
      margin: "0px 8px 0px -4px",
      fontSize: "1.8rem",
    },
  })
);
